<template>
  <div>首页</div>
</template>

<script>
import { getProductList } from "@/api/goods";
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(1111);
    this.getproductListData();
  },

  methods: {
    //随便获取接口跳转到登录界面
    async getproductListData() {
      let res = await getProductList({});
      if (res.status !== 1) {
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>